export default __webpack_public_path__ + "static/media/forestly-expl-dissect-06_DE.4adc236a.png";